// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1eCdZ","notes":"Notes_notes__1dB8Y","note":"Notes_note__3pYB4","markdown":"Notes_markdown__xEtKf"};